module.exports = __webpack_public_path__ + "static/media/Group40.ade2959c.png";